module.exports = __webpack_public_path__ + "asset/image/ic_amex-cee5.svg";